import { errorIconV2 } from '@/shared/ui/assets';
import { BIOTRES_OFFLINE_WARNING_MESSAGE } from '@/shared/config';
import './biotresOfflineWarning.scss';

/**
 * Renders the Biotres offline warning strip on the study details tab. Pairs the error icon with the shared offline warning message constant.
 *
 * @returns The offline warning banner.
 */
const BiotresOfflineWarning = () => (
  <div className="biotres-offline-warning-container">
    <img src={errorIconV2} alt="Warning 18px icon" />
    <div className="text">{BIOTRES_OFFLINE_WARNING_MESSAGE}</div>
  </div>
);

export default BiotresOfflineWarning;
